import { render, staticRenderFns } from "./SelectPlus.vue?vue&type=template&id=bad2c786&scoped=true"
import script from "./SelectPlus.vue?vue&type=script&lang=js"
export * from "./SelectPlus.vue?vue&type=script&lang=js"
import style0 from "./SelectPlus.vue?vue&type=style&index=0&id=bad2c786&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad2c786",
  null
  
)

export default component.exports